import type { GreenLoanSmallCalculatorResponse } from "./types";

export const GREEN_LOAN_LIMIT = 70_000_000;

export const DEFAULT_RESPONSE: GreenLoanSmallCalculatorResponse = {
	loanAmount: undefined,
	necesseryLoadAmount: undefined,
	loanMax70mEntitled: false,

	installmentMinAmount: undefined,
	installmentMaxAmount: undefined,

	// calc1
	calc1CsokEntitled: false,
	calc1CsokLoanAmount: undefined,
	calc1CsokLoanInstallment: undefined,

	calc1GreenLoanEntitled: false,
	calc1GreenLoanLoanAmount: undefined,
	calc1GreenLoanInstallment: undefined,
	calc1GreenLoanLoanAmountSum: undefined,
	calc1GreenLoanInstallmentSum: undefined,

	// calc2
	calc2CsokEntitled: false,
	calc2CsokLoanAmount: undefined,
	calc2CsokLoanInstallment: undefined,

	calc2GreenLoanEntitled: false,
	calc2GreenLoanLoanAmount: undefined,
	calc2GreenLoanInstallment: undefined,
	calc2GreenLoanLoanAmountSum: undefined,
	calc2GreenLoanInstallmentSum: undefined,

	// calc3
	calc3GreenLoanEntitled: false,
	calc3GreenLoanLoanAmount: undefined,
	calc3GreenLoanInstallment: undefined,
	calc3GreenLoanLoanAmountSum: undefined,
	calc3GreenLoanInstallmentSum: undefined,
};
